'use client';

import { useMediaQuery } from '@repo/hooks/useMediaQuery';
import { useEffect } from 'react';

export const useScrollLockOnMobile = (isEnabled: boolean) => {
  const isMobile = useMediaQuery('(max-width:768px)');

  useEffect(() => {
    if (isEnabled && isMobile) {
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
    } else {
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    };
  }, [isEnabled, isMobile]);
};
